






















import Header from '@/components/Header.vue';
import { getCategoriesWithTemplates } from '@/helpers/category';
import { Category } from '@/types/Category';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'Categories',
    components: { Header },
    computed: {
        availableCategories(): Category[] {
            if (!this.categories.length || !this.templates.length) {
                return [];
            }

            return getCategoriesWithTemplates(this.categories, this.templates);
        },
        ...mapGetters(['templates', 'categories']),
    },

    mounted() {
        this.$store.dispatch('fetchCategories');
        this.$store.dispatch('fetchTemplates');
    },
});
